import addClass from '../../../../general/class/addClass';
import removeClass from '../../../../general/class/removeClass';
import switchClass from '../../../../general/class/switchClass';

import * as exButton from '../../../../components/button';
import * as exIcon from '../../../icon';

import setUploadItemText from './setUploadItemText';

// ----------------------------------------------------------------------------

function createUploadActionButton(param: Record<string, any>): Record<string, any> {
    const elStatus = param.elements.uploadItemStatus;
    const elAction = param.elements.uploadItemRight;

    // ------------------------------------------------------------------------

    const elIcon = exIcon.create({
        type: 'fas fa-times',
    });

    const btnAction = exButton.create({
        attr: {
            title: 'Cancel',
        },
        class: {
            new: 'btn btn-sm text-danger',
        },
        html: elIcon,
        event: {
            click: function (): void {
                if (param.state.isCompleted === true || param.state.isAborted === true) {
                    if (!confirm('Remove this item?')) {
                        return;
                    }

                    param.element.remove();

                    param.state.isRemoved = true;
                } else {
                    if (!confirm('Cancel this upload?')) {
                        return;
                    }

                    param.controller.abort();

                    addClass(param.element, 'border-danger');

                    /*
                     * Written through the item's own setter, which knows the `custom` renderer the
                     * item was built with — a plain textContent write would replace caller-owned
                     * markup with a bare text node — and applies the status classes with it.
                     */
                    if (typeof param.setStatus === 'function') {
                        param.setStatus('Canceled');
                    } else {
                        setUploadItemText(elStatus, 'Canceled');
                    }

                    fnUpdateButtonAction();

                    param.state.isAborted = true;
                }
            },
        },
    });
    elAction.appendChild(btnAction.element);

    // ------------------------------------------------------------------------

    const fnUpdateButtonAction = function (): void {
        removeClass(btnAction.element, 'text-danger');
        switchClass(elIcon, 'fa-times', 'fa-trash');
        btnAction.element.title = 'Remove';
    };

    // ------------------------------------------------------------------------

    return {
        element: btnAction.element,
        fnUpdateButtonAction,
    };
}

// ----------------------------------------------------------------------------

export default createUploadActionButton;
